import React from "react";
import PropTypes from "prop-types";
import { Box, makeStyles } from "@material-ui/core";
import CuttedListIcon from "../atoms/icons/CuttedListIcon";
import ListIcon from "../atoms/icons/ListIcon";
import PercentIcon from "../atoms/icons/PercentIcon";
import { useTheme } from "@material-ui/styles";
import StyledButton from "../atoms/StyledButton";
import IconTitleDescription from "../atoms/IconTitleDescription";
import useCnaeContext from "../../contexts/CnaeContext";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      flexDirection: "column",
    },
  },
  buttonMobile: {
    display: "none",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      display: "block",
      marginTop: "24px",
    },
  },
}));

export default function InfoCnae() {
  const classes = useStyles();
  const theme = useTheme();
  const { currentCnae } = useCnaeContext();

  function fixDescriptionAliquota() {
    if (currentCnae.aliquota.indexOf("Sua empresa") !== -1) {
      return "Ativiade não enquadrada no Simples Nacional";
    }

    return currentCnae.aliquota;
  }

  const informations = [
    {
      key: Number(currentCnae._id),
      title: "CNAE",
      description: currentCnae.subclasse,
      icon: <ListIcon color={theme.palette.gray.main} />,
    },
    {
      key: Number(currentCnae._id) + 1,
      title: "ANEXO",
      description: currentCnae.simplesNacional.anexo,
      icon: <CuttedListIcon color={theme.palette.gray.main} />,
    },
    {
      key: Number(currentCnae._id) + 2,
      title: "ALÍQUOTA",
      description: fixDescriptionAliquota(),
      icon: <PercentIcon color={theme.palette.gray.main} />,
    },
  ];

  return (
    <Box className={classes.container}>
      {informations.map((information) => (
        <IconTitleDescription key={information.key} information={information} />
      ))}
      <Box className={classes.buttonMobile}>
        <StyledButton
          id="abrir-empresa-pesquisa-mobile"
          type={"dashed"}
          style={{ borderColor: "#31AEFF", color: "#31AEFF" }}
          text={"Abrir Empresa Grátis"}
          width="100%"
          onClick={() => {
            window.location.href = `${process.env.GATSBY_CONUBE_URL}/abrir-empresa`;
          }}
        />
      </Box>
    </Box>
  );
}

InfoCnae.propTypes = {
  currentCnae: PropTypes.object,
};
